import { get, post, put, del, fetchWithAuth } from '../utils/httpInterceptor';
import { buildCrudQueryParams } from './filterQueryBuilder';

const normalizeCompanyId = (companyId) => {
    const parsed = Number(companyId);
    if (!Number.isInteger(parsed) || parsed <= 0) {
        throw new Error('Invalid company id');
    }
    return parsed;
};

class CompanyService {

    static async getAll(page, size, filters = {}, sortConfig = {}) {
        const queryParams = buildCrudQueryParams({
            page,
            size,
            filters,
            sortConfig,
            sortMode: 'split',
        });
        return await get(`/company?${queryParams.toString()}`);
    }

    static async getById(companyId) {
        const safeId = normalizeCompanyId(companyId);
        return await get(`/company/${safeId}`);
    }

    static async create(jsonData) {
        return await post('/company', jsonData);
    }

    static async updateCompany(companyId, updatedCompany) {
        const safeId = normalizeCompanyId(companyId);
        return await fetchWithAuth(`/company/${safeId}`, {
            method: 'PUT',
            body: updatedCompany,
        });
    }

    static async update(companyId, formData) {
        const safeId = normalizeCompanyId(companyId);
        return await put(`/company/${safeId}`, formData);
    }

    static async delete(companyId) {
        const safeId = normalizeCompanyId(companyId);
        return await del(`/company/${safeId}`);
    }

    static async updateEnabled(companyId, updatedCompany) {
        const safeId = normalizeCompanyId(companyId);
        return await put(`/company/enabled/${safeId}`, updatedCompany);
    }
}

export default CompanyService;

